import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';

import Product from '../../models/product';
import Price from '../../models/price';
import ComboComponentManager from './ComboComponentManager';
import { getProducts } from '../../collections/products';

const CreateProduct = (props) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const [imageChange, setImageChange] = useState(false);
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isCombo, setIsCombo] = useState(false);
  const [components, setComponents] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    props.setPageTitle('Tạo mới sản phẩm');
    loadProducts();
  }, [props]);

  const loadProducts = async () => {
    try {
      const response = await getProducts({ status: 'ACTIVE' });
      if (response && response.data) {
        setAllProducts(response.data);
      }
    } catch (error) {
      console.error('Error loading products:', error);
    }
  };

  const uploadImage = async (imageFile) => {
    let data = new FormData();
    data.append('file', imageFile);
    let config = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: 'https://api.maysfarm.vn/api/v1/images',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJuZ3V5ZW50aGFpMjgxMUBnbWFpbC5jb20iLCJyb2xlIjoiQURNSU4iLCJleHAiOjEwMDAwMDAwMDAwMDE3MjQ4NDY5NTh9.KtSXIt4Du_lhqfZNwyGCETlCW9BaIXUujjSW60SfaqY',
      },
      data: data
    };
    try {
      const response = await axios.request(config);
      return response.data.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      setImageChange(true);
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImageChange(false);
    setImagePreview(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const data = new FormData(event.currentTarget);
    let validationErrors = {};
    if (!data.get('name')) validationErrors.name = 'Tên sản phẩm không được để trống';
    if (!data.get('price') || isNaN(data.get('price'))) validationErrors.price = 'Giá không được để trống hoặc không hợp lệ';
    if (!data.get('expire_days') || isNaN(data.get('expire_days'))) validationErrors.expire_days = 'Ngày hết hạn phải là số nguyên';
    if (!data.get('convert_rate') || isNaN(data.get('convert_rate'))) validationErrors.convert_rate = 'Tỷ lệ chuyển đổi phải là số phần trăm';
    if (isCombo && components.length === 0) validationErrors.components = 'Combo phải có ít nhất 1 thành phần';
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }
    else {
      let imageName = null;
      if (imageChange && imageFile) {
        imageName = await uploadImage(imageFile);
        if (!imageName) {
          setIsSubmitting(false);
          throw new Error('Lỗi upload hình ảnh!');
        }
        setUploadedImageName(imageName);
        setImageChange(false);
      }
      const product = new Product({
        name: data.get('name'),
        description: data.get('description'),
        image: imageName,
        expire_days: parseInt(data.get('expire_days'), 10),
        convert_rate: parseFloat(data.get('convert_rate')),
        is_combo: isCombo,
      });

      try {
        const response = await product.createProduct();
        if (response.success) {
          const productId = response.id;
          const currentDateTime = new Date().toISOString().split('.')[0];
          const price = new Price({
            product_id: productId,
            price: Number(data.get('price')),
            actived_at: currentDateTime,
          })

          const res = await price.addPrice();
          if (res.success) {
            // Add components if it's a combo
            if (isCombo && components.length > 0) {
              for (const comp of components) {
                await product.addComponent(productId, comp.component_product_id, comp.quantity);
              }
            }

            toast.success("Thêm sản phẩm thành công", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            navigate('/products');
          }
        }
        else {
          setError(response.message);
        }
      } catch (error) {
        console.error("API Response Data:", error.response?.data);
        let errorMessage = "Đã xảy ra lỗi không xác định!";

        if (error.response?.data?.error) {
          if (error.response.data.error.name) {
            errorMessage = "Tên đã tồn tại";
          } else if (error.response.data.error.image) {
            errorMessage = "Ảnh phải là jpg hoặc png";
          }
        }

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  }

  return (
    <Container maxWidth="md" sx={{ mt: 3, mb: 4 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate('/products')} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" component="h1" fontWeight="bold">
          Tạo sản phẩm mới
        </Typography>
      </Box>

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={3}>
          {/* Left Column - Basic Info */}
          <Grid item xs={12} md={8}>
            <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <InventoryIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" fontWeight="medium">
                  Thông tin cơ bản
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              <TextField
                margin="normal"
                fullWidth
                id="name"
                label="Tên sản phẩm"
                name="name"
                autoComplete="name"
                error={!!errors.name}
                helperText={errors.name}
                placeholder="Nhập tên sản phẩm..."
                autoFocus
              />

              <TextField
                margin="normal"
                fullWidth
                id="description"
                label="Mô tả"
                name="description"
                autoComplete="description"
                multiline
                rows={3}
                error={!!errors.description}
                helperText={errors.description}
                placeholder="Nhập mô tả sản phẩm..."
              />

              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="price"
                    label="Giá tiền"
                    name="price"
                    type="number"
                    error={!!errors.price}
                    helperText={errors.price}
                    placeholder="0"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">VNĐ</InputAdornment>,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="expire_days"
                    label="Hạn sử dụng"
                    id="expire_days"
                    type="number"
                    error={!!errors.expire_days}
                    helperText={errors.expire_days}
                    placeholder="7"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">ngày</InputAdornment>,
                    }}
                  />
                </Grid>
              </Grid>

              <TextField
                margin="normal"
                fullWidth
                name="convert_rate"
                label="Tỷ lệ chuyển đổi"
                id="convert_rate"
                type="number"
                error={!!errors.convert_rate}
                helperText={errors.convert_rate || "Tỷ lệ chuyển đổi từ kg sang đơn vị bán"}
                placeholder="1"
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
              />
            </Paper>

            {/* Combo Section */}
            <Paper elevation={2} sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <CategoryIcon color="secondary" sx={{ mr: 1 }} />
                <Typography variant="h6" fontWeight="medium">
                  Loại sản phẩm
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                bgcolor: isCombo ? 'secondary.50' : 'grey.50',
                borderRadius: 2,
                border: '1px solid',
                borderColor: isCombo ? 'secondary.200' : 'grey.200',
                transition: 'all 0.3s ease',
              }}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="medium">
                    Sản phẩm Combo
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Bật nếu sản phẩm này là tổ hợp của nhiều sản phẩm khác
                  </Typography>
                </Box>
                <Switch
                  checked={isCombo}
                  onChange={(e) => setIsCombo(e.target.checked)}
                  color="secondary"
                />
              </Box>

              {errors.components && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {errors.components}
                </Alert>
              )}

              {isCombo && (
                <Box sx={{ mt: 2 }}>
                  <ComboComponentManager
                    productId={null}
                    availableProducts={allProducts}
                    onComponentsChange={setComponents}
                  />
                </Box>
              )}
            </Paper>
          </Grid>

          {/* Right Column - Image & Actions */}
          <Grid item xs={12} md={4}>
            <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <ImageIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" fontWeight="medium">
                  Hình ảnh
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              {imagePreview ? (
                <Box sx={{ position: 'relative' }}>
                  <Box
                    component="img"
                    src={imagePreview}
                    alt="Preview"
                    sx={{
                      width: '100%',
                      height: 200,
                      objectFit: 'cover',
                      borderRadius: 2,
                      mb: 2,
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={handleRemoveImage}
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      bgcolor: 'error.main',
                      color: 'white',
                      '&:hover': {
                        bgcolor: 'error.dark',
                      },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: 200,
                    border: '2px dashed',
                    borderColor: 'grey.300',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'grey.50',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: 'primary.main',
                      bgcolor: 'primary.50',
                    },
                    mb: 2,
                  }}
                  component="label"
                >
                  <ImageIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    Click để tải ảnh lên
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    JPG, PNG (max 5MB)
                  </Typography>
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </Box>
              )}

              {!imagePreview && (
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  startIcon={<ImageIcon />}
                >
                  Chọn hình ảnh
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </Button>
              )}
            </Paper>

            {/* Actions */}
            <Paper elevation={2} sx={{ p: 3 }}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                disabled={isSubmitting}
                sx={{ mb: 2 }}
              >
                {isSubmitting ? 'Đang tạo...' : 'Tạo sản phẩm'}
              </Button>

              <Button
                fullWidth
                variant="outlined"
                onClick={() => navigate('/products')}
                disabled={isSubmitting}
              >
                Hủy bỏ
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )

}
export default CreateProduct;
